import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import WarningIcon from "@mui/icons-material/Warning";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        icon: {
            marginRight: spacing(3),
        },
    });
});
export default (function (_a) {
    var returnPage = _a.returnPage, routePath = _a.routePath;
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, { title: "Error" }),
        React.createElement(Box, { display: "flex", flexDirection: "column", bgcolor: "secondary.light", boxShadow: 1, marginTop: 3, marginX: 5, padding: 5 },
            React.createElement(Box, { display: "flex", alignItems: "center" },
                React.createElement(WarningIcon, { color: "error", fontSize: "large", className: classes.icon }),
                React.createElement(Typography, { variant: "h3" }, "The page you requested does not exist.")),
            React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
                React.createElement(Button, { variant: "contained", color: "primary", component: Link, to: {
                        pathname: routePath,
                    } }, returnPage)))));
});
//# sourceMappingURL=Screen.js.map